import { useTranslation } from 'react-i18next';

import {
	PrintPdfDialog,
	PrintPdfDialogProps,
} from 'modules/Shared/PdfPrint/PrintPdfDialog';

import { HealthCheckDialogContent } from './HealthCheckDialogContent';
import {
	PrintHealthCheckUserSettings,
	mapRecordToHealthCheckUserSettings,
} from './Types';
import { healthCheckPdfSettingsCategories } from './healthCheckSettingsCategory';

type PrintHealthCheckDialogProps = Omit<
	PrintPdfDialogProps<PrintHealthCheckUserSettings, unknown>,
	| 'ContentComponent'
	| 'mapRecordToPdfUserSettings'
	| 'pdfSettingsCategories'
	| 'title'
>;

export const PrintHealthCheckDialog = (props: PrintHealthCheckDialogProps) => {
	const { t } = useTranslation('healthCheck');

	return (
		<PrintPdfDialog
			ContentComponent={HealthCheckDialogContent}
			mapRecordToPdfUserSettings={mapRecordToHealthCheckUserSettings}
			pdfSettingsCategories={healthCheckPdfSettingsCategories}
			title={t('healthCheckPrintout-info-title')}
			{...props}
		/>
	);
};
